import { CloudUploadOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Space, Tooltip } from "antd";
import HTTPService from "../../../utils/makerequest";
import { IPageData, IPageProps } from "../../../interfaces/page-data";
import { useEffect, useRef, useState } from "react";
import { Toast } from 'primereact/toast';
import "../CompanyManagement/CustomerManagement.css";
import { IAuthentication, UserRole } from "../../../interfaces/authentication";
import { StateLoader } from "../../../redux/StateLoader";
import { useTranslation } from 'react-i18next';
import i18n from "../../../i18n";
import { ICloudConnector } from "../../../interfaces/ICloudConnector";
import MUIDatagrid, { IMUIDataGridColumns } from "../../../AltisComponent/MUIDataGrid";

interface IFilterData {
  count?: number;
  data?: ICloudConnector[];
}

const CloudConnectorManagement: React.FunctionComponent<IPageProps> = (props) => {
  const { onSetPage } = props;
  const toast = useRef<any>(null);

  const [cloudConnectList, setCloudConnectList] = useState<IFilterData>();
  const { t } = useTranslation();
  const loader = new StateLoader();
  const userInfo: IAuthentication = loader.loadAuthState();
  const dataGridRef = useRef<any>(null);

  const pageData: IPageData = {
    title: t('cloud_connector_management'),
    loaded: true
  };

  useEffect(() => {
    onSetPage(pageData);
    dataGridRef.current.GetAllData();
  }, [i18n.language]);

  const columns: IMUIDataGridColumns[] = [
    ...(userInfo.role == UserRole.AltisAdmin ? [{
      title: t('Company Name'),
      key: 'companyName',
      placeHolder: t('Company Name'),
      isSorting: true
    }] : []),
    { title: t('cloud_connector_name'), isSorting: true, key: 'cloudConnectorName', placeHolder: t('cloud_connector_name'), align: 'center', headerAlign: 'center' },
    { title: t('cloud_connector_guid'),hideColumnMenu:true ,isSorting: true, key: 'connectorGuid', placeHolder: t('cloud_connector_guid'), align: 'center', headerAlign: 'center'},
    {
      title: t('operations'),
      key: 'operations',
      align: 'center',
      hideColumnMenu: true,
      headerAlign: 'center',
      placeHolder: t('operations'),
      render: (order, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginTop: 10, marginLeft: 140 }}>
          <Space size={10}>
            <Popconfirm
              title={<div>{t('are_you_sure_cloud')} <br /></div>}
              onConfirm={() => DeletecloudConnector(record.cloudConnectorId)}
              okText={t('yes')}
              cancelText={t('no')}
            >
              <Tooltip title={t('delete')}>
                <Button
                  size='small'
                  icon={<DeleteOutlined />}
                  onClick={(e) => { e.stopPropagation(); }}
                  style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
                >
                </Button>
              </Tooltip>
            </Popconfirm>

            <Tooltip title={t('update')}>
              <Button
                size='small'
                icon={<EditOutlined />}
                onClick={() => window.location.replace('/admin/edit-cloud-connector/' + record.cloudConnectorId)}
                style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
              >
              </Button>
            </Tooltip>
          </Space>
        </div>
      ),
    }
  ];

  const CloudConnectorFilter = (e?) => {
    const filters = { ...e?.filters };
    const body = {
      pageSize: e?.pageSize,
      page: e?.page,
      cloudConnectorName: e?.cloudConnectorName,
      ...filters
    };

    HTTPService.POST(`/CloudConnector/filters`, body).then((response) => {
      if (!response.data) return;
      if (response.status === 200) {
        setCloudConnectList(response.data);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(response.data),
          life: 3000
        });
      }
    });
  };

  const DeletecloudConnector = (Id) => {
    HTTPService.DELETE(`/cloudConnector/delete?cloudConnectorId=${Id}`).then(
      (response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t(response.data),
            life: 3000
          });
          dataGridRef.current.GetAllData();
        } else if (response.status !== 450) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
      }
    );
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="row">
        <div className="mb-3">
          <Tooltip title={t('add_new_cloud_connector')}>
            <Button
              type="primary"
              shape="round"
              style={{
                height: 64,
                width: 'auto',
                backgroundColor: 'transparent',
                color: '#1890ff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: 'none',
                left: '-15px',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                visibility: userInfo.role === UserRole.Sayman ? 'hidden' : 'visible',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                e.currentTarget.style.color = '#40a9ff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.color = '#1890ff';
              }}
              size="middle"
              onClick={() => window.location.replace('/admin/edit-cloud-connector/0')}
            >
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%'
              }}>
                <CloudUploadOutlined style={{ fontSize: 24, marginBottom: '4px' }} />
                <span style={{
                  fontSize: '10px',
                  textAlign: 'center',
                  width: '100%',
                  lineHeight: '1.2'
                }}>
                  {t('add_new_cloud_connector')}
                </span>
              </div>
            </Button>
          </Tooltip>
        </div>

      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="table-container">
            <MUIDatagrid enableSelection={false} ref={dataGridRef} data={cloudConnectList?.data} total={cloudConnectList?.count} columns={columns} filterMode="server" onChange={CloudConnectorFilter} />
          </div>
        </div>
      </div>
    </>
  );
};

export default CloudConnectorManagement;
